import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { styled } from '@mui/material/styles';
import { Paper, Stack, Typography, Divider, } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import TextCircle from '../../../common/TextCircle';
import PanelTitle from '../PanelTitle';
const StyledDivider = styled(Divider)(({ theme }) => ({
    borderColor: theme.portal.site.lineColor,
    borderBottomWidth: 1,
    margin: '8px 1px 2px',
}));
const Accordion = styled((props) => (
// eslint-disable-next-line react/jsx-props-no-spreading
_jsx(MuiAccordion, { disableGutters: true, elevation: 0, square: true, ...props })))(() => ({
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));
const QuestionAnswer = ({ id, position, text, isQuestion, }) => (_jsxs(Stack, { direction: "row", spacing: 2, children: [_jsx(TextCircle, { outlined: !isQuestion, textStyle: { fontWeight: 'fontWeightBold' }, innerText: `${isQuestion ? 'Q' : 'A'}${position}` }), _jsx(Typography, { variant: isQuestion ? 'h5' : 'body2', sx: {
                // eslint-disable-next-line max-len
                fontSize: (theme) => (isQuestion ? theme.typography.h5.fontSize : theme.typography.body2.fontSize),
                color: isQuestion ? 'primary.main' : 'text.primary',
                fontWeight: isQuestion ? 'fontWeightBold' : 'fontWeightMedium',
                pt: isQuestion ? 0.975 : 0.35,
            }, children: text })] }, id));
const FAQContent = ({ faqs, config: { showTitle, showFaqs, faqsCount }, }) => (_jsxs(Paper, { elevation: 0, sx: { display: 'flex', flexDirection: 'column' }, children: [showTitle && _jsx(PanelTitle, { title: "FREQUENTLY ASKED QUESTIONS" }), console.log('all faqs', faqs), showFaqs && (faqs.slice(0, faqsCount).map((f, i) => (_jsxs(_Fragment, { children: [console.log('here faq', f, f.id, f.question), _jsxs(Accordion, { defaultExpanded: true, sx: { pl: 0.125 }, children: [_jsx(MuiAccordionSummary, { "aria-controls": "panel1a-content", id: "panel1a-header", expandIcon: _jsx(ExpandMoreIcon, { fontSize: "large", color: "primary" }), sx: { pl: 0 }, children: _jsx(QuestionAnswer, { isQuestion: true, id: `Q${f.id}`, position: i + 1, text: f.question }) }), _jsx(MuiAccordionDetails, { sx: { pl: 0 }, children: _jsx(QuestionAnswer, { isQuestion: false, id: `A${f.id}`, position: i + 1, text: f.answer }) })] }), _jsx(StyledDivider, {})] }))))] }));
FAQContent.defaultProps = {
    settings: {
        showTitle: true,
        showFaqs: true,
        faqsCount: 3,
    },
};
FAQContent.meta = {
    group: 'hidden',
    name: 'Course FAQs Tab',
    description: 'Component displays the course faqs structure',
    props: [
        {
            key: 'course',
            name: 'Course',
            type: 'course', // note this is a special type recognized by the system
            description: 'The course to display information about',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title on the FAQs panel',
        },
        {
            key: 'settings.showFaqs',
            name: 'Show FAQs',
            type: 'boolean',
            description: 'Show the faqs list on the FAQs panel',
        },
        {
            key: 'settings.faqsCount',
            name: 'FAQs count',
            type: 'number',
            description: 'Display limit for frequently asked questions.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'FAQs',
        props: {
            faqs: '@course.faqs',
            settings: {
                showTitle: true,
                showFaqs: true,
                faqsCount: 2,
            },
        },
    },
};
export default observer(FAQContent);
//# sourceMappingURL=FAQContent.js.map